import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { FormUI, Typography } from "@parkschannel/ui";
import { Filters } from "./Filters";
import { usePlanner, PlannerTree } from "../../../TripPlanner";
export const FiltersSection = ()=>{
    const { usePlannerFiltersQuery  } = usePlanner();
    const { data  } = usePlannerFiltersQuery();
    if (!data) return null;
    return /*#__PURE__*/ _jsx("section", {
        className: "bg-white py-6 px-4 rounded-2xl flex items-center md:px-6",
        children: /*#__PURE__*/ _jsxs(FormUI.Step, {
            className: "w-full",
            step: 2,
            status: "active",
            title: ()=>/*#__PURE__*/ _jsx(Typography, {
                    component: "h2",
                    variant: "h4",
                    className: classNames("text-neutral-900"),
                    children: "Make Your Plan"
                }),
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "bodyXL",
                    className: "mb-6 text-neutral-700",
                    children: "Access a curated list by choosing the kind of place you're going and what you plan to do there."
                }),
                /*#__PURE__*/ _jsx(Filters, {
                    data: PlannerTree.fromPlannerResourceDto(data)
                })
            ]
        })
    });
};
